import register from '@kpsys/angularjs-register';
import {GlobalSearchService} from './global-search.service';
import {KpGlobalSearchInputService} from './kp-global-search-input.service';

export default register('portaro.shared.global-search')
    .service(GlobalSearchService.serviceName, GlobalSearchService)
    .service(KpGlobalSearchInputService.serviceName, KpGlobalSearchInputService)
    .name();